import PropTypes from 'prop-types'
import { memo, useEffect, useMemo } from 'react'
import tagManager from 'app/tagManager'
import Content from 'components/content/Content/Content'
import Layout from 'components/core/Layout/Layout'
import NotifySymbol from 'components/elements/NotifySymbol/NotifySymbol'
import { useModalContext } from 'components/interface/Modal/provider/ModalProvider'
import styles from './UserInfo.module.scss'

/**
 * The `UserInfo`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function UserInfo (props) {
  const { isModalContentActive } = useModalContext()
  const { className } = props

  const content = useMemo(
    () => [
      {
        type: 'standard',
        align: 'center',
        content: '<p>You are now signed in!</p>'
      }
    ],
    []
  )

  /**
   * Effect: On mount, it means the user signed in
   * Dispatch the tracking event
   */
  useEffect(() => {
    tagManager.trackEvent({
      event: 'account.user-signed-in'
    })
  }, [])

  return (
    <div className={`${styles.userInfo} ${className}`.trimEnd()}>
      <Layout.Body align="center">
        <NotifySymbol className={styles.check} />
        <Content items={content} isActive={isModalContentActive} />
      </Layout.Body>
    </div>
  )
}

/** @type {object} */
UserInfo.propTypes = {
  className: PropTypes.string
}

/** @type {object} */
UserInfo.defaultProps = {
  className: ''
}

// Memoize
export default memo(UserInfo)
